import { useMemo } from 'react';
import { useUserPreferencesStore } from '@/store/UserPreferencesStore';
import type { UserPreferences } from '@/store/UserPreferencesStore';

export type { UserPreferences };

export function useUserPreferences() {
  const preferences = useUserPreferencesStore((state) => state.preferences);
  const setPreference = useUserPreferencesStore((state) => state.setPreference);
  const setAllPreferences = useUserPreferencesStore((state) => state.setAllPreferences);
  const logoutUser = useUserPreferencesStore((state) => state.logoutUser);
  const getUserName = useUserPreferencesStore((state) => state.getUserName);

  return useMemo(
    () => ({
      preferences,
      setPreference,
      setAllPreferences,
      logoutUser,
      getUserName
    }),
    [preferences, setPreference, setAllPreferences, logoutUser, getUserName]
  );
}
